export default {
  // 网站小程序登录-场景码组件
  getLoginMpCom: '/api/login-mp-com',
  // 网站小程序登录-场景码轮询
  getLoginMp: '/api/login-mp',
  getStudentNo2021: '/api/student/student-no-2021',
  getLoginInfo: '/api/auth/info',
  // 埋点
  getBuryDot: '/api/bury-dot',
  // 埋点-触发查询
  getBuryDotHits: '/api/bury-dot/hits',
  // 用户状态信息
  getUserStatus: '/api/student/status',
  // 获取国家
  getCountries: '/api/region/countries',
  getRegionCountryById: '/api/region/countries/{0}',
  // 获取省/州
  getStates: '/api/region/states',
  getRegionStateById: '/api/region/states/{0}',
  // 获取城市
  getCities: '/api/region/cities',
  getRegionCityById: '/api/region/cities/{0}',
  // 获取市辖区
  getZones: '/api/region/zones',
  getRegionZoneById: '/api/region/zones/{0}',
  // 获取市内学校
  getSchools: '/api/region/schools',
  getRegionSchoolById: '/api/region/schools/{0}',
  // 是否需要去完善信息
  isCompleted: '/api/student/isCompleted',
  // 获取 学生申请 表单状态
  getApplyStatus: '/api/student/apply/circle-status',
  // 获取学生申请 表单数据
  getStudentApply: '/api/student/apply',
  getStudentApply2: '/api/student/apply-step2',
  // 华夏学生申请 · 获取面试时间预约席位列表
  getStudentUserAppointmentSlots: '/api/student/user-appointments/slots',
  // 华夏学生申请 · 获取已提交的面试时间预约
  getStudentUserAppointment: '/api/student/user-appointments',
  getStudentSiApply: '/api/student/si/apply',
  // 获取 志愿者 表单状态
  getVolStatus: '/api/student/vol/apply/circle-status',
  // 获取 志愿者 表单数据
  getVolApply: '/api/student/vol/apply',
  // 获取志愿者录取表单
  getVolOfferLetter: '/api/student/volunteer/offer-letter',
  // 获取 学生完善 信息 数据
  getStudentInfo: '/api/student/info',
  // 轮询支付单支付状态
  getStudentPaymentIsPaid: '/api/student/payment/{0}/is-paid',
  // 会场押金是否已支付
  getStudentPlaceDepositIsPaid: '/api/student/place-deposit/is-paid',
  // 获取授权code
  getPaymentWechatOauth: '/api/payment/wechat/oauth',
  // 获取服务器时间
  getServerTime: '/api/clock',
  //查询 学生表填写步骤
  getStuApplyStep: '/api/student/apply/steps',
  // 查询 是否 已经申请
  getBursaryApply: '/api/student/bursary-apply',
  // 查询 录取信 状态
  getStuOfferLetter: '/api/student/offer-letter',
  // 获取 主修 Seminar
  getInterestedTracker: '/api/student/survey/interested-tracker',
  // 老师端 学生申请 数据
  getSchoolStuApply: '/api/school/student-apply',
  // 老师端 获取学校数据
  getSchoolInfo: '/api/school/info',
  // 老师端 导出申请列表
  getExportStuApply: '/api/school/student-apply-export',
  // 老师端 下载模板
  getRecommendTemplete: '/api/school/download-recommendation-import-template',
  // 获取sl个人信息
  getSLInfo: '/api/sl/info',
  // 获取sl申请信息
  getSLProfile: '/api/sl/profile',
  // 获取ccl申请信息
  getCCLProfile: '/api/sl/cl/profile',
  // 老师端 录取情况
  getSchoolAdmission: '/api/school/student-admission',
  // 老师端 上届学生
  getSchoolHistory: '/api/school/student-history',
  // 老师端 导出 录取进度excel
  getSchoolProgressExcel: '/api/school/student-admission/export',
  // 学校端 课程中心看课列表
  getSchoolCoursePreview: '/api/school/courses',
  // 学校端 课程中心看课详情
  getSchoolCourseDetailPreview: '/api/school/courses/{0}',
  // cs|cl选课
  // Seminar 列表
  getStudentCourseCenterCourses: '/api/student/course-center/courses',
  // cp 课程列表
  getStudentCourseCenterCoursesCP: '/api/student/course-center/courses-cp',
  // Seminar 详情
  getStudentCourseCenterCoursesDetail: '/api/student/course-center/courses/{0}',
  // Seminar 中心配置
  getStudentCourseCenterConfig: '/api/student/course-center/config',
  // Seminar 中心购物车
  getStudentCourseCart: '/api/student/course-center/cart',
  // 抢课Seminar 列表
  getStudentCourseCenterGrab: '/api/student/course-center/grab',
  // 选会场
  // 填写详情
  getStudentCourseCenterSurveyPlace: '/api/student/course-center/survey/place',
  // 游客代付
  // 查询付款信息
  getGuestPaymentPayFor: '/api/guest/payment/pay-for/{0}',
  // 抢地盘
  // 地图数据
  getGrabGameInfo: '/api/student/game/info',
  // rank 排名
  getStudentGameRank: '/api/student/game/rank',
  // 地图数据
  getTeacherGrabGameInfo: '/api/teacher/game/info',
  // rank 排名
  getTeacherGameRank: '/api/teacher/game/rank',
  // 分院信息 -- 老师端
  getTeacherHouseSorting: '/api/teacher/house/sorting',
  // 获取答题信息
  getStudentHouseSorting: '/api/student/house/sorting',
  getHouseSorting: '/api/house/sorting',
  // 现场补充信息
  getStudentCompleteInfo: '/api/student/complete/info',
  // 支付成功卡片信息
  getStudentSuccessCardStatus: '/api/student/success-card-status',
  // 支付成功卡片状态
  getStudentCompleteTimeline: '/api/student/complete/timeline',
  // academic-writing-workshop
  getStudentSurveyAcademicWritingWorkshopApply: '/api/student/survey/academic-writing-workshop-apply',
  // 教学管理端
  // 老师信息
  getTeacherInfo: '/api/teacher/info',
  // SL/TF Todo List
  getTeacherTodoList: '/api/teacher/todo-list',
  // 教师端-Dorm Check-学生列表
  getTeacherHouseStudentsManager: '/api/teacher/house/students-manager',
  // 教师端-管理-IndexHistory(状态历史)
  getTeacherHouseStudentsStatesId: '/api/teacher/house/students-states/{0}',
  // 管理Seminar 列表
  getTeacherManageList: '/api/teacher/manageList',
  // 课日程列表
  getTeacherDayList: '/api/teacher/dayList',
  // 教师端课程详情
  getTeacherCourse: '/api/teacher/course/{0}/{1}',
  // 签到列表
  getTearcherSign: '/api/teacher/sign',
  // 获取Seminar的Office Hour
  getTeacherHour: '/api/teacher/hour/{0}',
  // office hour预约详细
  getTeacherHourBooking: '/api/teacher/hour-booking/{0}',
  // 获取作业list
  getTeacherAssignment: '/api/teacher/assignment/{0}/{1}',
  // 作业提交详情（迟交、未交）
  getTeacherAssignmentInfo: '/api/teacher/assignment-info/{0}',
  // 获取Seminar分数
  getTeacherGradeCourse: '/api/teacher/grade/course/{0}/{1}',
  // 获取可同步 Grading Weight 的 Seminar
  getTeacherGradeCourseSyncPeriods: '/api/teacher/grade/course/{0}/{1}/sync-periods',
  // 获取学生分数
  getTeacherFradeStudent: '/api/teacher/grade/stu/{0}/{1}',
  // 打包作业下载
  getTeacherAssignmentDownload: '/api/teacher/assignment-download',
  // 学生端 获取Seminar接口
  getStudentClassMyCourses: '/api/student/class/my/courses',
  // 学生端 Seminar 详情
  getStudentClassCourses: '/api/student/class/course/{0}/{1}',
  // CP课题
  getStudentClassCPTask: '/api/student/class/cp/task',
  // 学生端 全部Seminar Seminar 详情
  getStudentAllClassCourses: '/api/student/class/course/{0}',
  // 学生端 office hour
  getStudentClassOfficeHour: '/api/student/class/office-hour/{0}',
  // 学生端 作业
  getStudentClassAssignment: '/api/student/class/assignment/{0}/{1}',
  // 学生全部作业
  getStudentClassAssignments: '/api/student/class/assignments',
  // 教师端签到列表
  getTeacherSign: '/api/teacher/sign/{0}',
  // 签到-二维码数据
  getStudentSignQRCodeData: '/api/student/sign-qrcode-data',
  // 学生签到接口
  getStudentClassSign: 'api/student/class/sign/{0}',
  // 学生端获取作业反馈
  getStudentClassFeedback: '/api/student/class/feedback/{0}/{1}',
  // 教师端签到Seminar信息
  getTeacherSignInfo: '/api/teacher/sign-info/{0}',
  // 教师端preview list
  getTeacherCoursePreview: '/api/teacher/courses',
  // 教师端preview list 详情
  getTeacherCourseDetailPreview: '/api/teacher/courses/{0}',
  // CP-Feedback小组列表
  getTeacherCPFeedback: '/api/teacher/cp-feedback/{0}',
  //sbp
  getStudentSurveySbpApply: '/api/student/survey/sbp-apply',
  // 申请 -- 信息发布
  getStudentSbpApply: '/api/student/sbp/apply',
  // 申请 -- 可选时间
  getStudentSbpApplyOptionTimes: '/api/student/sbp/apply/option-times',
  // 管理端-学生管理-学生列表
  getAdminStudents: '/api/admin/students',
  // 管理端-学生管理-请假记录
  getAdminStudentsIdTimeSheets: '/api/admin/students/{0}/time-sheets',
  // 管理端-学生管理-导出请假
  getAdminStudentsExportTimeSheets: '/api/admin/students/export/time-sheets',
  // 管理端-学生管理-TF反馈历史
  getAdminStudentsIdPersonalStates: '/api/admin/students/{0}/personal-states',
  // 管理端查看学生签到
  getAdminSigns: '/api/admin/signs',
  // 管理端查看作业提交情况
  getAdminAssignments: '/api/admin/assignments',
  // 管理端查看 Capstone Report 提交情况
  getAdminCapstoneReports: '/api/admin/capstone-reports',
  // 管理端查看 Capstone Reflection 提交情况
  getAdminCapstoneReflections: '/api/admin/capstone-reflections',
  // 管理端成绩管理接口
  getAdminGrades: '/api/admin/grades',
  // 管理端office hour
  getAdminOfficeHour: '/api/admin/office-hour',
  // 管理端 office hour导出
  getAdminOfficeHourExport: '/api/admin/office-hour/export',
  // 管理端 单课管理全部Seminar
  getAdminCourses: '/api/admin/courses',
  // 管理端 点击Seminar进去，获取Seminar信息
  getAdminCourse: '/api/admin/course/{0}',
  // 管理端 remove Seminar学生
  getAdminRemove: '/api/admin/remove/{0}',
  // 管理端 remove 下拉列表
  getAdminRemoveList: '/api/admin/remove-list/{0}',
  // 日历
  getStudentCalendar: '/api/student/calendar',
  getTeacherCalendar: '/api/teacher/calendar',
  // house cup
  // House Cup 排名
  getStudentHouseCup: '/api/student/house/cup',
  // House CPU 明细
  getStudentHouseCupDetail: '/api/student/house/cup/detail/{0}',
  // House Cup 排名
  getTeacherHouseCup: '/api/teacher/house/cup',
  // House CPU 明细
  getTeacherHouseCupDetail: '/api/teacher/house/cup/detail/{0}',
  // 读书会列表
  getStudentCourseCenterFC: '/api/student/course-center/fc',
  // 读书会Seminar 详情
  getStudentCourseCenterFCDetail: '/api/student/course-center/fc/{0}',
  // 列表
  getAdminHouseCup: '/api/admin/house-cup',
  // cornerstone workshop
  geTeacherCW: '/api/teacher/cw',
  //#region 新生抢课
  getStudentCourseCenterNewCs: '/api/student/course-center/new/cs',
  getStudentCourseCenterNewEns: '/api/student/course-center/new/ens',
  getStudentCourseCenterNewCns: '/api/student/course-center/new/cns?period={0}',
  getStudentCourseCenterNewCount: '/api/student/course-center/new/count',
  //#endregion 新生抢课
  //#region cw选课
  // 列表
  getStudentCourseCenterCw: '/api/student/course-center/cw',
  getStudentCourseCenterCwDetail: '/api/student/course-center/cw/{0}',
  //#endregion cw选课
  // 查询 house-reveal
  getStudentSurveyHouseReveal: '/api/student/survey/house-reveal',
  //#region master-class
  // 列表
  getCourseMasterClass: '/api/course/master-class',
  //#endregion master-class
  //#region forum
  getStudentForum: '/api/student/forum',
  getTeacherForum: '/api/teacher/forum',
  //#endregion forum
  //#region Mission X
  // 预约详情或可预约列表
  getStudentActivityMissionX: '/api/student/activity/mission-x',
  // Mission  X show
  getActivityMissionXShow: '/api/activity/mission-x-show',
  // 学生端随机信封
  getStudentActivityMissionXRandom: '/api/student/activity/mission-x/random',
  // 老师端端随机信封
  getTeacherActivityMissionXRandom: '/api/teacher/activity/mission-x/random',
  // 教师端 - 小队列表
  getActivityMissionX: '/api/activity/mission-x',
  //#endregion
  //#region Capstone Showcase
  // 列表
  getStudentCapstoneShowCase: '/api/student/capstone-show-case',
  getTeacherCapstoneShowCase: '/api/teacher/capstone-show-case',
  // 详情
  getStudentCapstoneShowCaseDetail: '/api/student/capstone-show-case/{0}',
  getTeacherCapstoneShowCaseDetail: '/api/teacher/capstone-show-case/{0}',
  // Capstone Expo
  getStudentActivityCapstoneExpo: '/api/student/activity/capstone-expo',
  //#endregion Capstone Showcase
  //#region 成绩查询
  // 登录用户查询成绩
  getStudentTranscript: '/api/student/transcript',
  //#endregion
  //#region 成绩单
  // 成绩单列表
  getStudentTranscriptDeliveryOrders: '/api/student/transcript/delivery/orders',
  getStudentTranscriptDeliveryOrderDetail: '/api/student/transcript/delivery/orders/{0}',
  //#endregion
  //#region 荣誉证书
  getStudentTranscriptCertificateDeliveryOrders: '/api/student/transcript/certificate/delivery/orders',
  getStudentTranscriptCertificateDeliveryOrderDetail: '/api/student/transcript/certificate/delivery/orders/{0}',
  getStudentTranscriptCertificatePreOrder: '/api/student/transcript/certificate/delivery/pre-order',
  getStudentSurvey2022CertLogistics: '/api/student/survey/2022-cert-logistics',
  //#endregion
  //#region 活动
  //#endregion
  //#region 志愿者申请
  // 查询 STEP 1
  getStudentVolApplyStep1: '/api/student/vol/apply/step1',
  // 查询 STEP 2
  getStudentVolApplyStep2: '/api/student/vol/apply/step2',
  // 查询志愿者邀请码
  getStudentInvitees: '/api/student/invitees',
  //#region 活动
  // 学生徽章列表接口
  getStudentActivityBadge: '/api/student/activity/badge',
  // 回忆杀
  getActivityHsylcMemory: '/api/activity/hsylc-memory',
  // 答案之书 - 问题列表
  getActivityAnswerBookQuestions: '/api/activity/answer-book/questions',
  // 答案之书 - 答案
  getActivityAnswerBookanswer: '/api/activity/answer-book/answer',
  // 答案之书 - 海报
  getActivityAnswerBookPoster: '/api/activity/answer-book/poster',
  // 抢课助力——获取数据
  getActivityCourse: '/api/activity/course/{0}',
  // 抢课助力——海报下载
  getActivityCoursePoster: '/api/activity/course-poster/{0}',
  // 抢课助力-发起人-集赞明细
  getActivityCourseqVoteLogs: '/api/activity/course/vote-logs',
  // 抢课助力-点赞人-基本信息
  getActivityCourseqVoter: '/api/activity/course/voter',
  //#endregion
  //#region club
  getStudentClubMy: '/api/student/club/my',
  //#endregion
  //#region  课程中心
  // 查询会场信息
  getStudentCourseSurveyPlace: '/api/student/course-center/survey/place',
  //#endregion
  // 虚拟校园入学信息查询
  getStudentVirtualCampusVisa: '/api/student/virtual_campus_visa',
  // WritingCenter信息发布
  getStudentCourseCenterWriting: '/api/student/course-center/writing',
  // WritingCenter 可选时间
  getStudentCourseCenterWritingOptionTimes: '/api/student/course-center/writing/option-times',
  // Business Review
  getStudentCourseCenterBusinessReview: '/api/student/course-center/business-review',
  // Academic Recourse列表
  getStudentCourseCenterAcademicResource: '/api/student/course-center/academic-recourse',
  // Academic Recourse
  getTeacherAcademicResource: '/api/teacher/academic-recourse',
  // 下载背景图片
  getStudentDownloadBg: '/api/student/download-bg',
  // 下载背景图片
  getTeacherDownloadBg: '/api/teacher/download-bg',
  //#region IM
  getStudentImInfo: '/api/student/im/info',
  getStudentImInfoByUser: '/api/student/im/info-by-user',
  getStudentImCheck: '/api/student/im/check',
  //#endregion
  getStudentSurveySbpApplyQa2022: '/api/student/survey/sbp-apply-qa-2022',
  getDDL: '/api/ddls',
  // 学生通用表单查询
  getStudentForm: '/api/student/form',
  //#region Seminar 课程
  // seminar领域排名
  getCourseCenterSeminarTrackRank: '/api/course-center/seminar-track-rank',
  // seminar课程列表
  getCourseCenterSeminar: '/api/course-center/seminar',
  //#endregion
  //#region 消息中心
  // 消息列表
  getStudentMessages: '/api/student/messages',
  getAdminMessages: '/api/admin/messages',
  //#endregion
  //#region FairGroup
  getAdminFairGroup: '/api/admin/fair-group',
  //#endregion
  //#region  老师教学管理
  // 分院-学生列表
  getTeacherHouseStudents: '/api/teacher/house/students',
  // 分院-学生导出
  getTeacherHouseStudentsExport: '/api/teacher/house/students/export',
  //#endregion
  // 金数据回调前置检查
  getStudentTranscriptPreCheck: '/api/student/transcript/pre-check',
  // 荣誉证书-订单信息
  getStudentTranscriptCertificateInfo: '/api/student/transcript/certificate/info',
  // 证书-获奖
  getStudentTranscriptCerts: '/api/student/transcript/certs',
  // 证书-渲染
  getStudentTranscriptCertImg: '/api/student/transcript/cert-img',
  // 往年成绩卡片权限
  getStudentTranscriptCardStatus: '/api/student/transcript/card-status',
  // 课程公布
  getStudentHXWeekCourses: '/api/student/hx-week/courses',
  // 获取HXWeek基本信息
  getStudentHXWeekInfo: '/api/student/hx-week/info',
  // deans list 基本信息
  getStudentDeansListInfo: '/api/student/deans-list/info',
  // deans list 课程公布
  getStudentDeansListCourses: '/api/student/deans-list/courses',
  // 开放-CLUB俱乐部月度排名（个人）
  getStudentTalentHuntRankMonthlyUser: '/api/student/talent-hunt/rank-monthly/user',
  // 开放-CLUB俱乐部年度排名（个人）
  getStudentTalentHuntRankAnnuallyUser: '/api/student/talent-hunt/rank-annually/user',
  // 开放-CLUB俱乐部总排名（个人）
  getStudentTalentHuntRankUser: '/api/student/talent-hunt/rank/user',
  // 开放-CLUB俱乐部月度排名(学院)
  getStudentTalentHuntRankMonthlyHouse: '/api/student/talent-hunt/rank-monthly/house',
  // 开放-CLUB俱乐部年度排名(学院)
  getStudentTalentHuntRankAnnuallyHouse: '/api/student/talent-hunt/rank-annually/house',
  // 开放-CLUB俱乐部月度排名(学院)
  getStudentTalentHuntRankHouse: '/api/student/talent-hunt/rank/house',
  // 学生录取动态
  getStudentApplyBulletins: '/api/student/apply/bulletins',
  //#region 1000件好事
  // 个人&个人学院提交统计
  getStudentGloriousDeeds: '/api/student/glorious-deeds',
  // 学院好事排名
  getStudentGloriousDeedsRank: '/api/student/glorious-deeds/rank',
  //#endregion
  // 我的CapstoneReports
  getStudentClassMyCapstoneReports: '/api/student/class/my/capstone-reports',
  // 我的CapstoneReport-详情
  getStudentClassMyCapstoneReportsDetail: '/api/student/class/my/capstone-reports/{0}',
  // 我的CapstoneReflections
  getStudentClassMyCapstoneReflections: '/api/student/class/my/capstone-reflections',
  // 我的CapstoneReflection-详情
  getStudentClassMyCapstoneReflectionsDetail: '/api/student/class/my/capstone-reflections/{0}',
  //#region 花名册
  getStudentFacebookRosters: '/api/student/facebook-rosters',
  getTeacherFacebookRosters: '/api/teacher/facebook-rosters',
  getEaMaFacebookRosters: '/api/ea-ma/facebook-rosters',
  //#endregion
  //#region 电子证书
  // 证书-年份
  transcriptCertYears: '/api/student/transcript/cert-years',
  // 证书-获奖
  transcriptCerts: '/api/student/transcript/certs',
  // 证书-渲染
  transcriptCertImg: '/api/student/transcript/cert-img',
  getSchoolGradePosterDetail: '/api/school/grade/poster/detail',
  //#endregion
};
